import { eventBus, createObserve } from '@mtfe/sweet-utils';
import store from '../../store/index';

const { storeCommon } = store;
const onReady = () => {
    eventBus.$on('ready', () => {
        eventBus.$emit('WelfareTabsReady');
        if (storeCommon.isShowRedBag) {
            eventBus.$emit('RedBagComponentReady');
        }
        if (storeCommon.isShowCoupon) {
            eventBus.$emit('CouponComponentReady');
        }
    });
};


export default onReady;
